import {useNavigate, useSearchParams} from "react-router-dom";
import {dvirSelector, useGetDVIRQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {DVIRProfile} from "../../components/profile/DVIRProfile/DVIRProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const DVIRProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.dvir", "DVIR") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <DVIRProfilePage id={id}/>;
};

export const DVIRProfilePage = (props: Props) => {
  const {id} = props;

  const selectDVIR = useMemo(() => {
    return dvirSelector()
  }, []);

  const {dvir, isFetching} = useGetDVIRQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      dvir: selectDVIR(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage
      entity={dvir}
      isLoading={isFetching}
      permissions={["dvir_view"]}
    >
      {(entity) => (
        <DVIRProfile dvir={entity}/>
      )}
    </EntityProfilePage>
  )
};
